import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import Typography from '@mui/material/Typography';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import BackIcon from '@mui/icons-material/ArrowBack';
import { useAppSelector } from '../../../../hooks';
import { selectMatchState } from '../../../../store/match';
import { ETeam, getRoleString, TeamName, TMatchResultCase } from '../../../../types';
import { Delimiter } from '../../../atoms/Delimiter';
import { DataContainerNew } from '../../../atoms/DataContainer';
const Logo = styled.p `
  font-family: 'TuesdayNight';
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 42px;
`;
const PageContainer = styled(DataContainerNew) `
  flex-direction: column;
  align-items: center;
`;
const FlexContainer = styled.div `
  display: flex;
  justify-content: center;
`;
const ButtonsContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 613px;
`;
const getWinnerString = (result) => {
    switch (result) {
        case TMatchResultCase.MAFIA_WIN:
            return 'Мафия победила';
        case TMatchResultCase.CIVILIANS_WIN:
            return 'Мирные победили';
        case TMatchResultCase.FOOLS_WIN:
            return 'Дурак обвел всех вокруг пальца';
        default:
            return 'Ничья';
    }
};
const getTeamsList = (winCase) => {
    // eslint-disable-next-line default-case
    switch (winCase) {
        case TMatchResultCase.FOOLS_WIN:
            return [ETeam.FOOLS, ETeam.MAFIA, ETeam.CIVILIANS];
        case TMatchResultCase.CIVILIANS_WIN:
            return [ETeam.CIVILIANS, ETeam.MAFIA, ETeam.FOOLS];
        case TMatchResultCase.MAFIA_WIN:
            return [ETeam.MAFIA, ETeam.FOOLS, ETeam.CIVILIANS];
    }
    return [ETeam.CIVILIANS, ETeam.MAFIA, ETeam.FOOLS];
};
const getPlayerName = (player) => {
    if (player.player.gameName !== null) {
        return (_jsxs(_Fragment, { children: [player.player.gameName, "\u00A0", _jsxs("span", { children: ["(", player.player.realName, ")"] })] }));
    }
    return player.player.realName;
};
export function FinalTable() {
    var _a, _b, _c;
    const matchState = useAppSelector(selectMatchState);
    const nav = useNavigate();
    const onClickBack = () => {
        if (matchState === null) {
            return;
        }
        nav(`/matches?eventId=${matchState.eventId}`);
    };
    const allGamePlayers = useMemo(() => ((matchState === null || matchState === void 0 ? void 0 : matchState.state.players) || []), [matchState]);
    const playersInTeam = (team) => allGamePlayers === null || allGamePlayers === void 0 ? void 0 : allGamePlayers.filter((p) => p.team === team);
    const event = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.event) || null;
    const winCase = (_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.winCase;
    const teams = getTeamsList(winCase);
    const getTable = (team) => (_jsx(Table, { children: _jsx(TableBody, { children: playersInTeam(team).map((player) => (_jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: getPlayerName(player) })) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Typography, Object.assign({ variant: "body2" }, { children: (player === null || player === void 0 ? void 0 : player.isAlive) ? 'Выжил' : 'Убит' })) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: getRoleString(player.role) })), _jsxs(TableCell, Object.assign({ variant: "body", align: "center" }, { children: ["\u0420\u0435\u0439\u0442\u0438\u043D\u0433: ", player.rating] }))] }, player.id))) }) }));
    const getBlock = (team) => {
        const players = playersInTeam(team);
        if (players.length === 0) {
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return _jsx(_Fragment, {});
        }
        return (_jsxs(_Fragment, { children: [_jsxs(Typography, Object.assign({ align: "center", variant: "h4" }, { children: [TeamName(team), ": ", playersInTeam(team).length] })), _jsx(Delimiter, { top: "14px" }), getTable(team), _jsx(Delimiter, { top: "20px" })] }));
    };
    return (_jsxs(PageContainer, { children: [_jsx(ButtonsContainer, { children: _jsx(Button, Object.assign({ onClick: () => onClickBack(), startIcon: _jsx(BackIcon, {}) }, { children: "\u041A \u0430\u0444\u0438\u0448\u0435" })) }), _jsx(Delimiter, { top: "20px" }), _jsxs(Paper, Object.assign({ sx: { width: '100%', maxWidth: '613px' } }, { children: [_jsx(Delimiter, { top: "20px" }), _jsx(FlexContainer, { children: _jsxs("div", { children: [_jsx(Typography, Object.assign({ align: "center", variant: "h4" }, { children: _jsx("span", { children: (event === null || event === void 0 ? void 0 : event.date) || '' }) })), _jsx(Typography, Object.assign({ align: "center", variant: "h2" }, { children: getWinnerString(((_c = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _c === void 0 ? void 0 : _c.winCase) || '') }))] }) }), _jsx(Delimiter, { top: "20px" }), _jsx(Delimiter, { top: "20px" }), teams.map((team) => getBlock(team))] }))] }));
}
